import React from 'react';

import { CardListFilterMenuPoint3 } from '@vlabs/monokit/entities/cards/filters';

export function ListDetailsFilterMenu(): React.JSX.Element {
  return (
    <CardListFilterMenuPoint3 exclude={['list_ids']} />
  );
}
